import {
  addMinutes,
  addYears,
  formatDuration,
  intervalToDuration,
  subYears,
} from 'date-fns';

export const CALENDAR_START_MONTH = subYears(new Date(), 5);
export const CALENDAR_END_MONTH = addYears(new Date(), 5);

export const shortenDurationString = (duration: string) =>
  duration.replace(/ hours?/, ' hr').replace(/ minutes?/, ' min');

export const minutesToDuration = (minutes: number) => {
  const start = new Date(0);
  const end = addMinutes(start, minutes);

  const duration = intervalToDuration({ start, end });

  return shortenDurationString(
    formatDuration(duration, { format: ['hours', 'minutes'], delimiter: ' ' })
  );
};

export const isDateValid = (date: Date) => !Number.isNaN(date.getTime());
